import axios from 'axios';
import { map, compose, addIndex, filter, keys } from 'ramda';
import store from 'store/store';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import env from 'consts/env';

export const apiInstance = axios.create({
  baseURL: `${env.API_ENDPOINT}/${env.API_VERSION}`,
});

export const apiSurveyInstance = axios.create({
  baseURL: `${env.API_SURVEY_ENDPOINT}/${env.API_SURVEY_VERSION}`,
});

apiInstance.interceptors.request.use(
  function (config) {
    const state = store.getState();
    const token = StoreProvider.selectors.authSelectors.token(state);
    if (token) {
      config.headers['Authorization'] = `JWT ${token}`;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiInstance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

apiSurveyInstance.interceptors.request.use(
  function (config) {
    const state = store.getState();
    const token = StoreProvider.selectors.authSelectors.token(state);
    if (token) {
      config.headers['Authorization'] = `JWT ${token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiSurveyInstance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

export const mapWithIndex = addIndex(map);
export const parseSegments = (segments: boolean[]): number[] =>
  compose(
    map(({ id }: { id: number; value: boolean }) => id),
    filter(({ value }: { id: number; value: boolean }) => value === true),
    mapWithIndex((value: boolean, index: number) => ({
      id: index,
      value: value,
    }))
  )(segments);
export const parseCountries = (countries: {
  [key: string]: boolean;
}): string[] =>
  compose(
    map(({ id }: { id: string; value: boolean }) => id),
    filter(({ value }: { id: number; value: boolean }) => value === true),
    map((key: string) => ({
      id: key,
      value: countries[key],
    })),
    keys
  )(countries);
